import { useIntersectionObserver } from 'reactApp/hooks/useInterSectionObserver';

const mobileThreshold = 0.3;
const desktopThreshold = 0.5;

export const useIntersecObsrWithParams = ({
    onIntersecting,
    onIntersectingOut,
    isMobile,
    headerHeight,
    threshold,
}: {
    onIntersecting: () => void;
    onIntersectingOut?: () => void;
    isMobile: boolean;
    headerHeight?: number;
    threshold?: number;
}) => {
    const thresholdValue = isMobile ? mobileThreshold : desktopThreshold;

    return useIntersectionObserver({
        onIntersecting,
        onIntersectingOut,
        rootMargin: `${headerHeight || 0}px`,
        threshold: threshold !== undefined ? threshold : thresholdValue,
    });
};
